import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { useWindowSize } from '@react-hook/window-size';
import QuestionaryStep1 from './Step1/QuestionaryStep1';
import SelectGoalsStep2 from './Step2/SelectGoalsStep2';
import Step2Level2 from './Step2/Step2Level2';
import EstablishActionStep3 from './Step3/EstablishActionStep3';
import Step5MidYearReview from './Step1/Step5MidYearReview';
import Step12 from './Step1/Step12/Step12';

import AppContext from '../Context/AppContext';
import requestAxios from '../util/requestAxios';
import Header from './Dashboard/Header/HeaderDashboard';
import Network from './Network/Network';
import configData from '../config.json';
import CStepper from './Common/Header/CStepper';
import CStepperLevel2 from './Common/Header/CStepperLevel2';
import './Steps.css';
import '../App.css';

const App = () => {
    const { updateUserStepId, checkUserSession,changeLoading } = useContext(AppContext);
    const [, setWindowWidth] = useState(window.innerWidth);
    const onWindowResize = useGlobalEvent('resize');
    const [mobile, setMobile] = useState(window.innerWidth <= 768);
    const [userStatus, setUserStatus] = useState({});
    const history = useHistory();
    const [, height] = useWindowSize();
    // const [currentStep,changeCurrentStep]=useState(-1);
    onWindowResize((event) => {
        setMobile(window.innerWidth <= 768);
        setWindowWidth(window.innerWidth);
    });

    const [indexStep, handleChangeindexStep] = useState(0);
    const [indexLevelStep, changeIndexLevelStep] = useState(0);
    const [headerActive, handleChangeHeader] = useState(1);
    const [profile, setProfile] = useState(null);

    function change(i) {
        handleChangeindexStep(i);
    }

    const handleChangeDirect = () => {};

    async function getCustomerProfileInformation() {
        const us = checkUserSession();
        const url = `Customer/GetCustomerProfileInfo/${us.userId}`;
        const { error, data } = await requestAxios({
            url: url,
            token: us.token,
        });
        if (error) {
            console.log(error);
        } else {
            setProfile(data);
        }
    }

    useEffect(() => {
        let cancelled = false;

        (async () => {
            const previewParam = (() => {
                try {
                    return new URLSearchParams(window.location.search).get(
                        'preview'
                    );
                } catch {
                    return null;
                }
            })();
            const forceStep1 =
                previewParam === 'fun-final' ||
                previewParam === 'fun' ||
                previewParam === 'fun-start' ||
                previewParam === 'fitness' ||
                previewParam === 'fitness-questions' ||
                previewParam === 'questions' ||
                previewParam === 'fitness-final' ||
                previewParam === 'section-complete' ||
                previewParam === 'step1-final' ||
                previewParam === 'step1-complete';
            const forceStep2 =
                previewParam === 'step2' ||
                previewParam === 'step2-goals' ||
                previewParam === 'goals' ||
                previewParam === 'step2-pick7' ||
                previewParam === 'pick7' ||
                previewParam === 'top7' ||
                previewParam === 'step2-arrange' ||
                previewParam === 'arrange' ||
                previewParam === 'arrange7' ||
                previewParam === 'step2-oolaone' ||
                previewParam === 'oolaone' ||
                previewParam === 'oola1' ||
                previewParam === 'step2-finish' ||
                previewParam === 'step2-complete' ||
                previewParam === 'finish';
            const forceStep3 =
                previewParam === 'step3' ||
                previewParam === 'step3-actions' ||
                previewParam === 'actions' ||
                previewParam === 'step3-tracker' ||
                previewParam === 'tracker' ||
                previewParam === 'step3-finish';

            // Dev preview: jump into Step 1 assessment (70 FS questions)
            if (forceStep1) {
                handleChangeindexStep(1);
                handleChangeHeader(1);
                changeLoading(false);
                try {
                    await updateUserStepId();
                } catch {
                    /* ignore */
                }
                if (!cancelled) await getCustomerProfileInformation();
                return;
            }

            // Dev preview: jump into Step 2 before any step redirects
            if (forceStep2) {
                handleChangeindexStep(2);
                handleChangeHeader(1);
                changeLoading(false);
                try {
                    await updateUserStepId();
                } catch {
                    /* ignore */
                }
                if (!cancelled) await getCustomerProfileInformation();
                return;
            }

            // Dev preview: jump into Step 3 (actions / classic tracker)
            if (forceStep3) {
                handleChangeindexStep(3);
                handleChangeHeader(1);
                changeLoading(false);
                try {
                    await updateUserStepId();
                } catch {
                    /* ignore */
                }
                if (!cancelled) await getCustomerProfileInformation();
                return;
            }

            try {
                const userStepCheck = await updateUserStepId();
                if (cancelled) return;
                setUserStatus(userStepCheck || {});
                const userStepId = Number(userStepCheck?.userStepId);
                const userInfo = checkUserSession() || {};

                if (userInfo.userTypeId === 4) {
                    history.push('/nonSubscriber');
                    return;
                }

                if (userStepId < 4 && userStepId >= 1) {
                    handleChangeindexStep(userStepId);
                } else if (userStepId === 5) {
                    handleChangeindexStep(5);
                    handleChangeHeader(0);
                } else if (userStepId === 6) {
                    handleChangeindexStep(6);
                    handleChangeHeader(2);
                    changeIndexLevelStep(0);
                } else if (userStepId === 7) {
                    handleChangeindexStep(7);
                    handleChangeHeader(2);
                    changeIndexLevelStep(1);
                } else if (userStepId === 0) {
                    history.push('/customizeQuestions');
                } else if (userStepId > 3) {
                    history.push('/dashboard');
                }

                await getCustomerProfileInformation();
            } catch (err) {
                console.log(err);
                changeLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="steps__container">
            <Header mobile={mobile} steps="1" profile={profile} />
            {headerActive === 1 && (
                <CStepper indexStep={indexStep - 1} mobile={mobile} />
            )}
            {headerActive === 2 && (
                <CStepperLevel2 indexStep={indexLevelStep} mobile={mobile} />
            )}
            {indexStep === 1 && (
                <QuestionaryStep1
                    indexStepChange={change}
                    mobile={mobile}
                    handleChangeHeader={handleChangeHeader}
                    userStatus={userStatus}
                    headerActive={headerActive}
                />
            )}
            {indexStep === 2 && (
                <SelectGoalsStep2
                    handleChangeindexStep={handleChangeindexStep}
                    handleChangeHeader={handleChangeHeader}
                    mobile={mobile}
                />
            )}
            {indexStep === 3 && (
                <EstablishActionStep3
                    handleChangeHeader={handleChangeHeader}
                    mobile={mobile}
                />
            )}
            {indexStep === 5 && (
                <Step5MidYearReview
                    indexStepChange={change}
                    mobile={mobile}
                    handleChangeHeader={handleChangeHeader}
                    userStatus={userStatus}
                />
            )}
            {indexStep === 6 && (
                <section className="step1__container">
                    <div className={'step12__container '}>
                        <Step12
                            changeStepIndex={change}
                            configData={configData}
                            mobile={mobile}
                            height={height}
                            handleChangeHeader={handleChangeHeader}
                            userStatus={userStatus}
                            handleChange={handleChangeDirect}
                            changeIndexLevelStep={changeIndexLevelStep}
                        />
                    </div>
                </section>
            )}
            {indexStep === 7 && (
                <Step2Level2
                    handleChangeindexStep={handleChangeindexStep}
                    handleChangeHeader={handleChangeHeader}
                    mobile={mobile}
                />
            )}
            <Network />
        </div>
    );
};

export default App;
